<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { showNotification } from '~/dashboard/vue/notifications/notification_actions';

const key: string = '3eb6d9c14bbc40af80617873e2c98a7d';

// const show = ref(localStorage.getItem(key) !== null ? key === 'true' : true)
const show = ref(false);

function copy() {
  navigator.clipboard.writeText('GSPHJMG81S');
  showNotification('any_type', {
    emoji: '👌',
    title: 'Code has been successfully copied to clipboard',
  });
}

function close() {
  document.querySelector('.header-container')?.classList.remove('header-container__banner');
  document.querySelector('.main-content')?.classList.remove('pt-xxl');
  show.value = false;
  localStorage.setItem(key, 'false');
}

function use() {
  window.location.replace('/settings');
}

onMounted(() => {
  if (show.value) {
    document.querySelector('.header-container')?.classList.add('header-container__banner');
    document.querySelector('.main-content')?.classList.add('laptop:pt-xxl');
  }
});
</script>

<template>
  <div v-if="show" class="pointer-events-auto flex h-[48px] justify-center bg-[#99DC81] text-black">
    <div class="m-auto flex items-center">
      <span class="mr-[12px] text-[16px]">🎅</span>
      <span class="text-caption-s mr-s">
        Happy New Year! <b>15% off</b> any annual plan with your promo code: <b>GSPHJMG81S</b> (valid until 1/31/2024)
      </span>
      <span class="flex gap-xs">
        <button class="tppr-button ghost s w-[112px] !border-black !bg-transparent !text-black" @click="copy">
          <span class="tppr-button__text">Copy code</span>
        </button>

        <button class="tppr-button s w-[112px] !bg-black !text-[#99DC81]" @click="() => use()">
          <span class="tppr-button__text">Use</span>
        </button>

        <button @click="close">
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.3291 4L12.3291 12" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.3291 12L12.3291 4" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </span>
    </div>
  </div>
</template>
